import React, { useEffect, useMemo, useState } from "react";
import { resolveMediaUrl } from "../../../utils/resolveMediaUrl";

function getInitials(name) {
  const parts = String(name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  const one = parts[0] ?? "?";
  return one.slice(0, 2).toUpperCase();
}

function hashString(value) {
  let hash = 0;
  const s = String(value ?? "");
  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

function avatarPalette(seed) {
  const h = hashString(seed) % 360;
  return {
    bg: `hsl(${h} 48% 38%)`,
    ring: `hsl(${h} 55% 82%)`,
    glow: `hsla(${h} 70% 45% / 0.28)`,
  };
}

export default function UserDirectoryMemberCell({ photo, name, userCode, layout = "inline" }) {
  const [imgFailed, setImgFailed] = useState(false);
  const url = resolveMediaUrl(photo);
  const showImage = Boolean(url) && !imgFailed;
  const displayName = String(name ?? "").trim() || "—";
  const code = String(userCode ?? "").trim();
  const initials = useMemo(() => getInitials(displayName), [displayName]);
  const palette = useMemo(() => avatarPalette(displayName || code || "user"), [displayName, code]);

  useEffect(() => {
    setImgFailed(false);
  }, [url]);

  const layoutClass =
    layout === "profile"
      ? " ub-member-cell--profile"
      : layout === "header"
        ? " ub-member-cell--header"
        : "";

  return (
    <div className={`ub-member-cell${layoutClass}`}>
      <div
        className={`ub-member-avatar${showImage ? " ub-member-avatar--photo" : " ub-member-avatar--initials"}`}
        style={
          showImage
            ? { "--ub-avatar-ring": palette.ring, "--ub-avatar-glow": palette.glow }
            : {
                "--ub-avatar-bg": palette.bg,
                "--ub-avatar-ring": palette.ring,
                "--ub-avatar-glow": palette.glow,
              }
        }
      >
        {showImage ? (
          <img
            src={url}
            alt=""
            className="ub-member-avatar__img"
            loading="lazy"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <span className="ub-member-avatar__initials" aria-hidden>
            {initials}
          </span>
        )}
        <span className="ub-member-avatar__ring" aria-hidden />
      </div>

      <div className="ub-member-meta">
        <span className="ub-member-name">{displayName}</span>
        {code ? <span className="ub-member-code">{code}</span> : null}
      </div>
    </div>
  );
}
